export type NullableStringList = Array<string | null | undefined> | null | undefined;

export const parseCommaSeparatedValues = (value: string): string[] => {
  if (!value) {
    return [];
  }

  const seen = new Set<string>();
  const result: string[] = [];

  value
    .split(',')
    .map(item => item.trim())
    .filter(Boolean)
    .forEach(item => {
      if (!seen.has(item)) {
        seen.add(item);
        result.push(item);
      }
    });

  return result;
};

export const formatCommaSeparatedValues = (values: NullableStringList): string => {
  if (!values || values.length === 0) {
    return '';
  }

  const filtered = values
    .map(value => (value ?? '').trim())
    .filter((value): value is string => value.length > 0);

  return filtered.length > 0 ? filtered.join(', ') : '';
};
